var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7125 35.3996C44.7125 36.0596 44.1613 36.5996 43.4875 36.5996H7.35C6.67625 36.5996 6.125 36.0596 6.125 35.3996V13.7996C6.125 13.1396 6.67625 12.5996 7.35 12.5996H43.4875C44.1613 12.5996 44.7125 13.1396 44.7125 13.7996V35.3996Z",
    fill: "#ECF0F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4867 37.2H7.34922C6.30797 37.2 5.51172 36.42 5.51172 35.4V13.8C5.51172 12.78 6.30797 12 7.34922 12H43.4867C44.528 12 45.3242 12.78 45.3242 13.8V35.4C45.3242 36.42 44.528 37.2 43.4867 37.2ZM7.34922 13.2C6.98172 13.2 6.73672 13.44 6.73672 13.8V35.4C6.73672 35.76 6.98172 36 7.34922 36H43.4867C43.8542 36 44.0992 35.76 44.0992 35.4V13.8C44.0992 13.44 43.8542 13.2 43.4867 13.2H7.34922Z",
    fill: "#CACED3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7125 22.6202C44.7125 23.0402 44.1613 23.4002 43.4875 23.4002H7.35C6.67625 23.4002 6.125 23.0402 6.125 22.6202V19.4402C6.125 19.0202 6.67625 18.6602 7.35 18.6602H43.4875C44.1613 18.6602 44.7125 19.0202 44.7125 19.4402V22.6202Z",
    fill: "#EBECEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4867 24H7.34922C6.30797 24 5.51172 23.4 5.51172 22.62V19.44C5.51172 18.6 6.30797 18 7.34922 18H43.4867C44.528 18 45.3242 18.6 45.3242 19.38V22.56C45.3242 23.4 44.528 24 43.4867 24ZM7.34922 19.2C6.98172 19.2 6.73672 19.38 6.73672 19.44V22.62C6.73672 22.68 6.98172 22.8 7.34922 22.8H43.4867C43.8542 22.8 44.038 22.68 44.0992 22.56V19.38C44.0992 19.32 43.8542 19.2 43.4867 19.2H7.34922Z",
    fill: "#CACED3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0508 30H27.5633V31.2H22.0508V30Z",
    fill: "#CACED3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 33H31.2375V34.2H18.375V33Z",
    fill: "#CACED3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledCard);
export default __webpack_public_path__ + "static/media/FilledCard.b5ffb60a224f70e76103f886c194e2d4.svg";
export { ForwardRef as ReactComponent };